import { render, staticRenderFns } from "./inputs-section-frame.vue?vue&type=template&id=20f8fcd2&scoped=true"
import script from "./inputs-section-frame.vue?vue&type=script&lang=js"
export * from "./inputs-section-frame.vue?vue&type=script&lang=js"
import style0 from "./inputs-section-frame.vue?vue&type=style&index=0&id=20f8fcd2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f8fcd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f8fcd2')) {
      api.createRecord('20f8fcd2', component.options)
    } else {
      api.reload('20f8fcd2', component.options)
    }
    module.hot.accept("./inputs-section-frame.vue?vue&type=template&id=20f8fcd2&scoped=true", function () {
      api.rerender('20f8fcd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/components/inputs-section-frame.vue"
export default component.exports